import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/**
 * Primary UI component for user interaction
 */
export const Carousel = ({ data = [], classes, sliderClasses, itemClasses, ...props }) => {
  const [viewportWidth, setViewportWidth] = useState(0);

  useEffect(() => {
    const updateViewportWidth = () => {
      setViewportWidth(window.innerWidth);
    };

    updateViewportWidth();
    window.addEventListener('resize', updateViewportWidth);

    return () => {
      window.removeEventListener('resize', updateViewportWidth);
    };
  }, []);

  const carouselSetting = {
    infinite: false,
    dots: props.dot,
    arrows: props.arrows,
    speed: 500,
    slidesToShow: viewportWidth < 640 ? 1.07 : 2.07,
    slidesToScroll: 1,
  };

  const Wrapper = viewportWidth < 1024 ? Slider : 'div';

  return (
    <div className={['card-carousel-container', 'w-full', classes && classes].join(' ')}>
      <Wrapper
        className={['card-carousel lg:flex lg:flex-row lg:gap-4', sliderClasses && sliderClasses].join(' ')}
        {...(viewportWidth < 1024 ? carouselSetting : {})}
      >
        {data.map(item => (
          <div className={['carousel-item pr-4 lg:pr-0 lg:grow w-full', itemClasses && itemClasses].join(' ')}>
            {item}
          </div>
        ))}
      </Wrapper>
    </div>
  );
};

Carousel.propTypes = {
  /**
   * This is all our carousel array items
   */
  data: PropTypes.array,

  sliderClasses: PropTypes.string,

  itemClasses: PropTypes.string,
};
